import { CClient } from '@common/utils'
import Footer from '@components/common/footer'
import NavBar from '@components/common/navbar'
// import TabbedSection from '@components/common/tabbed-section'
import QuizList from '@components/quizzes/quiz-list'
import { USER_COUNTRY_FROM_IP_COOKIE } from '@lib/constants/common'
import { COMPETITION_TYPES } from '@lib/constants/competitions'
import { QUIZZES_PAGE_SIZE } from '@lib/constants/quizzes'
import { quizzesListSeo } from '@lib/seo'
// import { TabType } from '@lib/types/common'
import { CompetititonsListType } from '@lib/types/competitions'
import { QuizLinkedEntityType } from '@lib/types/quizzes'
import {
  formatCountryQuery,
  getCountryFromIP,
  getServerSideRedirectResult,
} from '@lib/utils/common'
import { GetServerSideProps } from 'next'
import { FAQPageJsonLd, NextSeo } from 'next-seo'
import { useRouter } from 'next/router'
import { parseCookies } from 'nookies'
import Faq from '@components/home/faq'
import { QUIZZES_FAQ_CONTENTS } from '@lib/data/faq'
import TextImageCommonFold from '@components/common/text-image-common-fold'
// import useTabs from '@hooks/quizzes/useTabs'
// import { getQuizSectionTabs } from '@lib/utils/quizzes'

type Props = {
  quizzes: CompetititonsListType<QuizLinkedEntityType>
  // tabs: QuizTabType[]
  nextPage: string
}

const QuizzesPage = ({ quizzes, nextPage }: Props) => {
  // const { activeTab, setActiveTab } = useTabs({
  //   defaultTab: {
  //     value: QUIZ_LIST_SECTIONS.PRACTICE,
  //     label: QUIZ_LIST_SECTIONS.PRACTICE,
  //   },
  // })
  const router = useRouter()

  return (
    <>
      <NextSeo {...quizzesListSeo} />
      <FAQPageJsonLd
        mainEntity={QUIZZES_FAQ_CONTENTS.map(
          ({ acceptedAnswerTextString, questionName }) => ({
            acceptedAnswerText: acceptedAnswerTextString,
            questionName: questionName,
          })
        )}
      />

      <div className="bg-grey-100">
        <NavBar next={router.asPath} />
        <div className="container px-5 pt-5 pb-10 mx-auto md:px-10">
          <h1 className="pt-8 pb-3 text-2xl leading-tight text-center text-grey lg:text-4xl font-700">
            <span className="underlined-text">Coding quizzes</span> for kids and
            teens
          </h1>
          <p className="text-center pb-8">
            Great collection of fun and interactive coding quizzes for kids to
            assess and acquire computer science knowledge.
          </p>
          {/* <TabbedSection
            activeTab={activeTab}
            setActiveTab={setActiveTab}
            tabs={tabs}
            tabFontSize="lg"
          > */}
          <QuizList quizzes={quizzes} nextPage={nextPage} />
          {/* </TabbedSection> */}
        </div>
      </div>

      <div className="mb-8">
        <TextImageCommonFold
          title={
            <>
              Our Coding Quiz Activities & Games Are Appropriate for High
              School, Middle School, and Elementary School Students
            </>
          }
          description={
            <>
              <p>
                Our coding quizzes are designed to engage students from
                elementary through high school. Each quiz encourages active
                participation, helping students apply their knowledge in fun and
                interactive ways.
              </p>
              <p>
                These quizzes challenge learners’ current coding skills by
                providing a score and correct answers after each quiz.
                Additionally, students are offered a free trial lesson related
                to the quiz to further enhance their knowledge. The trial
                includes a 45-minute 1:1 session with an expert computer science
                teacher, along with personalized notes and a graded assignment.
              </p>
              <p>
                We also offer STEM.org-accredited certificates, which students
                can share on social media or with mentors. These certificates
                not only validate their skills but also enhance their learning
                portfolios, providing a competitive edge for university
                applications and career opportunities.
              </p>
              <p>
                To support learning across all grade levels, we offer a variety
                of quizzes for Grades 1-12. Popular quizzes like
                &ldquo;Introduction to Scratch Programming,&rdquo;
                &ldquo;Fundamentals of Python Programming,&rdquo; and
                &ldquo;Introduction to Data Science&rdquo; give students the
                opportunity to showcase their coding expertise. With real-time
                leaderboards and exciting quiz competitions, students can learn,
                compete, and have fun while testing their knowledge!
              </p>
            </>
          }
          imagePath="/images/quizzes/codingal-school-kids"
          imageWidth={370}
          imageHeight={370}
        />
        <Faq faqContents={QUIZZES_FAQ_CONTENTS} />
      </div>
      <Footer />
    </>
  )
}

export const getServerSideProps: GetServerSideProps = async (ctx) => {
  const token = parseCookies(ctx).token
  const countryCode =
    parseCookies(ctx)?.[USER_COUNTRY_FROM_IP_COOKIE] ||
    (await getCountryFromIP(ctx))
  const countryQuery = formatCountryQuery(countryCode)
  const response = await CClient(
    `/api/v1/competitions/?competition_type=${COMPETITION_TYPES.QUIZ_CONTEST}&page_size=${QUIZZES_PAGE_SIZE}${countryQuery}&order_by_quiz_difficulty=Ascending&is_practice=True`,
    {
      headers: {
        Authorization: token ? `Token ${token}` : null,
        'Content-Type': 'application/json',
        cookie: ctx.req.headers.cookie,
      },
    }
  )

  if (!response.ok)
    return getServerSideRedirectResult(ctx, `/${response.status}`)

  const data = await response.json()

  const serverEndpoint = process.env.SSR_API_ENDPOINT || ''
  const clientEndpoint = process.env.CSR_API_ENDPOINT || ''
  const nextPage =
    data?.next && serverEndpoint && clientEndpoint
      ? (data.next as string).replace(serverEndpoint, clientEndpoint)
      : data?.next

  const quizzes: CompetititonsListType<QuizLinkedEntityType> = data.results

  // const tabs: TabType[] = getQuizSectionTabs(quizzes)

  return {
    props: {
      quizzes,
      // tabs,
      nextPage,
    },
  }
}

export default QuizzesPage
